import React from 'react';
import { connect } from 'react-redux';
import ResetPasswordTokenContent from '../components/pages/user/reset-password-token/content';

function ResetPasswordTokenPage(props) {
  return (
    <div>
      <ResetPasswordTokenContent userEmail={props.userEmail} />
    </div>
  );
}

export default ResetPasswordTokenPage;
